import { Core } from '@springtree/eva-services-core';
import productDetailConfigurableState from './product-detail-configurable-state.js';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from '../current-user/current-user-state.js';
// We need to recurse the child product arrays to find all stock holding products
//
const buildStockHoldingProductsForConfigurableProductQuanityRequests = (products) => {
    const stockHoldingProducts = products.filter((product) => {
        // Stock holding means not being configurable themselves
        //
        return product.Type !== 16384;
    });
    // Build the requests and recursively add the child items
    //
    const quantityRequests = [];
    stockHoldingProducts.forEach((product) => {
        quantityRequests.push({
            ID: product.ProductID,
            QuantityRequested: 1,
        });
        const childQuantityRequests = buildStockHoldingProductsForConfigurableProductQuanityRequests(product.Children || []);
        quantityRequests.push(...childQuantityRequests);
    });
    return quantityRequests;
};
const productDetailsAvailabilityState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailConfigurableAvailability',
    service: Core.GetProductAvailability,
    beforeRequest: ({ req, get }) => {
        const currentConfigurableProduct = get(productDetailConfigurableState.response);
        const currentUser = get(currentUserState.response);
        if (!currentConfigurableProduct || !currentConfigurableProduct.Configurable.Children.length) {
            return;
        }
        const organizationUnitsForPickup = [];
        if (currentUser?.User?.CurrentOrganizationID) {
            organizationUnitsForPickup.push(currentUser.User.CurrentOrganizationID);
        }
        // We will fetch availability for all stock holding products that are
        // an option for this configurable product
        //
        const stockHoldingProductRequests = buildStockHoldingProductsForConfigurableProductQuanityRequests(currentConfigurableProduct.Configurable.Children);
        if (!stockHoldingProductRequests.length) {
            return;
        }
        const newRequest = {
            Options: {
                Bundles: {
                    IncludeBundleInformation: true,
                },
                Delivery: {
                    AvailabilityDate: true,
                },
                Pickup: {
                    AvailabilityDate: true,
                    OrganizationUnitIDs: organizationUnitsForPickup,
                },
                QuantityAvailable: true,
                ProductAvailabilityDetails: {
                    OrganizationUnitIDs: organizationUnitsForPickup,
                    ProductIDs: stockHoldingProductRequests.map(product => product.ID),
                },
            },
            ...req,
            Products: stockHoldingProductRequests,
        };
        return newRequest;
    },
});
export default productDetailsAvailabilityState;
//# sourceMappingURL=product-detail-configurable-availability-state.js.map